import * as React from 'react';

import { cn, TouchButton } from '@rematter/ui-web';
import { useSetAtom } from 'jotai';
import { LucideExternalLink } from 'lucide-react';

import { NormalizedFreightCharge } from '../_types';

import { $openFreightDetails } from '~/modules/trade/_state/materialsInterface.state';
import { useTranslations } from '~/modules/trade/i18n/useTranslations';

type FreightEditButtonFieldProps = {
  freightCharge: NormalizedFreightCharge;
  disabled?: boolean;
};

//
// ⚛️ ⚛️ ⚛️ FREIGHT EDIT BUTTON FIELD ⚛️ ⚛️ ⚛️
//
export const FreightEditButtonField: React.FC<FreightEditButtonFieldProps> = ({
  freightCharge,
  disabled,
}) => {
  // Translations
  const t = useTranslations();

  // Atoms
  const openFreightDetails = useSetAtom($openFreightDetails);

  // Callbacks
  const handleEdit = React.useCallback(() => {
    openFreightDetails({
      lineItemId: freightCharge.id,
      notes: freightCharge.notes,
    });
  }, [freightCharge.id, freightCharge.notes, openFreightDetails]);

  return (
    <TouchButton
      variant="ghost"
      onPress={handleEdit}
      isDisabled={disabled}
      aria-label={t.scaleTicketPro.itemsInterface.editFreightDetails}
      className={cn('@FreightEditButtonField', 'max-h-[44px]')}
      isSelected={false}
    >
      <LucideExternalLink className="size-4" />
    </TouchButton>
  );
};
